var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderLogoAnimated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    width: 154,
    height: 44,
    viewBox: "0 0 154 44",
    style: {
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_26_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.861244;0.923445;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_26_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.462 -7.524",
    to: "-2.462 -7.524",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.462 -7.524;-2.462 -7.524",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_26_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.9282297;0.9282297;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_25_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.8468899;0.9090909;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_25_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.649 -7.399",
    to: "-2.649 -7.399",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.649 -7.399;-2.649 -7.399",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_25_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.9138756;0.9138756;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_24_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.8325359;0.8947368;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_24_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.586 -7.337",
    to: "-2.586 -7.337",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.586 -7.337;-2.586 -7.337",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_24_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.8995215;0.8995215;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_23_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.8181818;0.8803828;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_23_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.421 -2.483",
    to: "-2.421 -2.483",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.421 -2.483;-2.421 -2.483",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_23_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.8851675;0.8851675;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_22_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.8038277;0.8660287;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_22_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.421 -2.421",
    to: "-2.421 -2.421",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.421 -2.421;-2.421 -2.421",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_22_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.8708134;0.8708134;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_21_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.7894737;0.8516746;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_21_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.457 -2.394",
    to: "-2.457 -2.394",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.457 -2.394;-2.457 -2.394",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_21_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.8564593;0.8564593;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_20_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.7751196;0.8373206;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_20_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.421 -2.608",
    to: "-2.421 -2.608",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.421 -2.608;-2.421 -2.608",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_20_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.8421053;0.8421053;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_19_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.7607655;0.8229665;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_19_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-5.059 -5.183",
    to: "-5.059 -5.183",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-5.059 -5.183;-5.059 -5.183",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_19_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.8277512;0.8277512;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_18_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.7464115;0.8086124;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_18_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-7.149 -7.274",
    to: "-7.149 -7.274",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-7.149 -7.274;-7.149 -7.274",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_18_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.8133971;0.8133971;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_17_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.7320574;0.7942584;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_17_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-5.904 -6.028",
    to: "-5.904 -6.028",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-5.904 -6.028;-5.904 -6.028",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_17_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.7990431;0.7990431;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_16_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.7177033;0.7799043;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_16_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-7.274 -2.712",
    to: "-7.274 -2.712",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-7.274 -2.712;-7.274 -2.712",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_16_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.784689;0.784689;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_15_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.7033493;0.7655502;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_15_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-7.337 -2.274",
    to: "-7.337 -2.274",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-7.337 -2.274;-7.337 -2.274",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_15_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.7703349;0.7703349;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_14_G",
    fill: "freeze",
    attributeName: "transform",
    from: "1 1",
    to: "0 0",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.6889952;0.7511962;1",
    values: "1 1;1 1;0 0;0 0",
    keySplines: "0.167 0 0.833 0.833;0.167 0 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_14_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.358 -2.483",
    to: "-2.358 -2.483",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.358 -2.483;-2.358 -2.483",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_14_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.430622;0.4306225;0.7559809;0.7559809;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_13_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.2392344;0.3110048;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_13_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.462 -7.524",
    to: "-2.462 -7.524",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.462 -7.524;-2.462 -7.524",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_13_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.2392344;0.2392349;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_12_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.2248804;0.2966507;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_12_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.649 -7.399",
    to: "-2.649 -7.399",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.649 -7.399;-2.649 -7.399",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_12_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.2248804;0.2248809;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_11_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.2105263;0.2822967;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_11_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.586 -7.337",
    to: "-2.586 -7.337",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.586 -7.337;-2.586 -7.337",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_11_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.2105263;0.2105268;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_10_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.1961722;0.2679426;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_10_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.421 -2.483",
    to: "-2.421 -2.483",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.421 -2.483;-2.421 -2.483",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_10_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.1961722;0.1961727;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_9_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.1818182;0.2535885;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_9_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.421 -2.421",
    to: "-2.421 -2.421",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.421 -2.421;-2.421 -2.421",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_9_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.1818182;0.1818187;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_8_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.1674641;0.2392344;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_8_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.457 -2.394",
    to: "-2.457 -2.394",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.457 -2.394;-2.457 -2.394",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_8_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.1674641;0.1674646;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_7_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.15311;0.2248804;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_7_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.421 -2.608",
    to: "-2.421 -2.608",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.421 -2.608;-2.421 -2.608",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_7_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.15311;0.1531105;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_6_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.1052632;0.1770335;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_6_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-5.059 -5.183",
    to: "-5.059 -5.183",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-5.059 -5.183;-5.059 -5.183",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_6_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.1052632;0.1052636;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_5_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.0909091;0.1626794;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_5_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-7.149 -7.274",
    to: "-7.149 -7.274",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-7.149 -7.274;-7.149 -7.274",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_5_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.0909091;0.0909096;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_4_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.076555;0.1483254;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_4_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-5.904 -6.028",
    to: "-5.904 -6.028",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-5.904 -6.028;-5.904 -6.028",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_4_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.076555;0.0765555;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_3_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.062201;0.1339713;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_3_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-7.274 -2.712",
    to: "-7.274 -2.712",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-7.274 -2.712;-7.274 -2.712",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_3_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.062201;0.0622014;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_2_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.0478469;0.1196172;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_2_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-7.337 -2.274",
    to: "-7.337 -2.274",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-7.337 -2.274;-7.337 -2.274",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_2_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 0,
    to: 0,
    keyTimes: "0;0.0478469;0.0478474;0.430622;0.430622;1",
    values: "0;0;1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_1_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.0717703;1",
    values: "0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_1_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-2.358 -2.483",
    to: "-2.358 -2.483",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-2.358 -2.483;-2.358 -2.483",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "6.9736403s",
    begin: "0s",
    xlinkHref: "#_R_G_L_1_G_M",
    fill: "freeze",
    attributeName: "opacity",
    from: 1,
    to: 0,
    keyTimes: "0;0.430622;0.430622;1",
    values: "1;1;0;0",
    keySplines: "0 0 0 0;0 0 0 0;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "opacity",
    dur: "7s",
    from: 0,
    to: 1,
    xlinkHref: "#time_group"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_R_G"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_27_G",
    transform: " translate(77.125, 22) translate(-0.125, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_27_G_D_0_P_0",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M77.25 -22 C77.25,-22 77.25,22 77.25,22 C77.25,22 -77,22 -77,22 C-77,22 -77,-22 -77,-22 C-77,-22 77.25,-22 77.25,-22z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_27_G_D_1_P_0",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0,
    strokeOpacity: 0.45,
    d: " M77.25 -22 C77.25,-22 77.25,22 77.25,22 C77.25,22 -77,22 -77,22 C-77,22 -77,-22 -77,-22 C-77,-22 77.25,-22 77.25,-22z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_26_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_26_G",
    transform: " translate(30.193, 22.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_26_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_26_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_25_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_25_G",
    transform: " translate(25.69, 26.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_25_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_25_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_24_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_24_G",
    transform: " translate(20.937, 31.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_24_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_24_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_23_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_23_G",
    transform: " translate(16.163, 31.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_23_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_23_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_22_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_22_G",
    transform: " translate(11.555, 26.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_22_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_22_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_21_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_21_G",
    transform: " translate(9.286, 24.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_21_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M7.16 2.55 C7.16,2.55 2.55,7.16 2.55,7.16 C2.55,7.16 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 7.16,2.55 7.16,2.55z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_21_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M7.16 2.55 C7.16,2.55 2.55,7.16 2.55,7.16 C2.55,7.16 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 7.16,2.55 7.16,2.55z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_20_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_20_G",
    transform: " translate(2.215, 17.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_20_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M0.25 4.86 C0.25,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 9.47,4.86 9.47,4.86 C9.47,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 0.25,4.86 0.25,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_20_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M0.25 4.86 C0.25,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 9.47,4.86 9.47,4.86 C9.47,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 0.25,4.86 0.25,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_19_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_19_G",
    transform: " translate(11.827, 12.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_19_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M7.37 2.68 C7.37,2.68 2.68,7.37 2.68,7.37 C2.68,7.37 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 7.37,2.68 7.37,2.68z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_19_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M7.37 2.68 C7.37,2.68 2.68,7.37 2.68,7.37 C2.68,7.37 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 7.37,2.68 7.37,2.68z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_18_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_18_G",
    transform: " translate(16.345, 17.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_18_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_18_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_17_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_17_G",
    transform: " translate(19.708, 23.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_17_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M7.18 4.86 C7.18,4.86 4.86,7.18 4.86,7.18 C4.86,7.18 0.25,2.57 0.25,2.57 C0.25,2.57 2.58,0.25 2.58,0.25 C2.58,0.25 7.18,4.86 7.18,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_17_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M7.18 4.86 C7.18,4.86 4.86,7.18 4.86,7.18 C4.86,7.18 0.25,2.57 0.25,2.57 C0.25,2.57 2.58,0.25 2.58,0.25 C2.58,0.25 7.18,4.86 7.18,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_16_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_16_G",
    transform: " translate(23.403, 15.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_16_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_16_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_15_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_15_G",
    transform: " translate(28.155, 10.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_14_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_14_G",
    transform: " translate(16.182, 3.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_14_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_14_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_13_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_13_G",
    transform: " translate(30.193, 22.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_13_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_13_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_12_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_12_G",
    transform: " translate(25.69, 26.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_12_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_12_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_11_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_11_G",
    transform: " translate(20.937, 31.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_11_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_11_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_10_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_10_G",
    transform: " translate(16.163, 31.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_10_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_10_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_9_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_9_G",
    transform: " translate(11.555, 26.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_9_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_9_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_8_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_8_G",
    transform: " translate(9.286, 24.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_8_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M7.16 2.55 C7.16,2.55 2.55,7.16 2.55,7.16 C2.55,7.16 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 7.16,2.55 7.16,2.55z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_8_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M7.16 2.55 C7.16,2.55 2.55,7.16 2.55,7.16 C2.55,7.16 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 7.16,2.55 7.16,2.55z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_7_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_7_G",
    transform: " translate(2.215, 17.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M0.25 4.86 C0.25,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 9.47,4.86 9.47,4.86 C9.47,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 0.25,4.86 0.25,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M0.25 4.86 C0.25,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 9.47,4.86 9.47,4.86 C9.47,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 0.25,4.86 0.25,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_6_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_6_G",
    transform: " translate(11.827, 12.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M7.37 2.68 C7.37,2.68 2.68,7.37 2.68,7.37 C2.68,7.37 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 7.37,2.68 7.37,2.68z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M7.37 2.68 C7.37,2.68 2.68,7.37 2.68,7.37 C2.68,7.37 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 7.37,2.68 7.37,2.68z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_5_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_5_G",
    transform: " translate(16.345, 17.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_5_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_5_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_4_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_4_G",
    transform: " translate(19.708, 23.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M7.18 4.86 C7.18,4.86 4.86,7.18 4.86,7.18 C4.86,7.18 0.25,2.57 0.25,2.57 C0.25,2.57 2.58,0.25 2.58,0.25 C2.58,0.25 7.18,4.86 7.18,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M7.18 4.86 C7.18,4.86 4.86,7.18 4.86,7.18 C4.86,7.18 0.25,2.57 0.25,2.57 C0.25,2.57 2.58,0.25 2.58,0.25 C2.58,0.25 7.18,4.86 7.18,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_3_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_3_G",
    transform: " translate(23.403, 15.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_3_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_3_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_2_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_2_G",
    transform: " translate(28.155, 10.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_2_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_2_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.55 4.86 C9.55,4.86 4.86,9.55 4.86,9.55 C4.86,9.55 0.25,4.94 0.25,4.94 C0.25,4.94 4.94,0.25 4.94,0.25 C4.94,0.25 9.55,4.86 9.55,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_1_G_M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_1_G",
    transform: " translate(16.182, 3.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_1_G_D_0_P_0",
    stroke: "#00bc41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_1_G_D_1_P_0",
    fill: "#00bc41",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M9.47 4.86 C9.47,4.86 4.86,9.47 4.86,9.47 C4.86,9.47 0.25,4.86 0.25,4.86 C0.25,4.86 4.86,0.25 4.86,0.25 C4.86,0.25 9.47,4.86 9.47,4.86z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_0_G",
    transform: " translate(97.738, 27.79) translate(-56.512, -14.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_0_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M106.02 27 C106.02,27 108.19,27 108.19,27 C108.22,27.21 108.35,27.39 108.59,27.53 C108.82,27.66 109.09,27.73 109.41,27.73 C109.75,27.73 110.01,27.67 110.21,27.55 C110.42,27.42 110.52,27.27 110.52,27.08 C110.52,26.9 110.43,26.76 110.27,26.67 C110.11,26.57 109.82,26.48 109.39,26.41 C109.39,26.41 108.36,26.22 108.36,26.22 C107.65,26.1 107.1,25.84 106.72,25.44 C106.34,25.05 106.15,24.55 106.15,23.93 C106.15,23.15 106.45,22.53 107.05,22.06 C107.64,21.6 108.42,21.36 109.36,21.36 C110.39,21.36 111.18,21.58 111.75,22.02 C112.31,22.46 112.6,23.06 112.61,23.82 C112.61,23.82 110.52,23.82 110.52,23.82 C110.51,23.59 110.4,23.4 110.19,23.26 C109.98,23.12 109.72,23.05 109.4,23.05 C109.1,23.05 108.87,23.11 108.69,23.23 C108.51,23.34 108.42,23.49 108.42,23.69 C108.42,23.87 108.51,24.02 108.67,24.13 C108.84,24.24 109.11,24.32 109.48,24.39 C109.48,24.39 110.55,24.57 110.55,24.57 C111.31,24.7 111.87,24.95 112.23,25.32 C112.59,25.69 112.77,26.18 112.77,26.82 C112.77,27.61 112.46,28.25 111.84,28.72 C111.23,29.19 110.4,29.43 109.37,29.43 C108.31,29.43 107.49,29.22 106.91,28.8 C106.32,28.37 106.02,27.77 106.02,27z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_1_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M101.73 29.43 C100.53,29.43 99.59,29.08 98.9,28.37 C98.21,27.66 97.86,26.67 97.86,25.39 C97.86,24.12 98.21,23.13 98.9,22.42 C99.59,21.71 100.53,21.36 101.73,21.36 C102.42,21.36 103.03,21.5 103.58,21.77 C104.13,22.05 104.56,22.43 104.88,22.93 C105.2,23.43 105.35,24 105.35,24.63 C105.35,24.63 103.16,24.63 103.16,24.63 C103.13,24.19 102.99,23.83 102.73,23.57 C102.46,23.29 102.13,23.16 101.73,23.16 C101.26,23.16 100.89,23.36 100.61,23.75 C100.34,24.15 100.2,24.69 100.2,25.39 C100.2,26.09 100.34,26.64 100.61,27.03 C100.88,27.43 101.26,27.63 101.74,27.63 C102.13,27.63 102.46,27.49 102.72,27.23 C102.99,26.96 103.13,26.6 103.17,26.15 C103.17,26.15 105.36,26.15 105.36,26.15 C105.36,26.79 105.2,27.35 104.89,27.86 C104.58,28.36 104.15,28.74 103.6,29.02 C103.05,29.29 102.43,29.43 101.73,29.43z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_2_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M96.97 29.29 C96.97,29.29 94.68,29.29 94.68,29.29 C94.68,29.29 94.68,21.49 94.68,21.49 C94.68,21.49 96.97,21.49 96.97,21.49 C96.97,21.49 96.97,29.29 96.97,29.29z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_3_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M91.85 29.29 C91.85,29.29 89.55,29.29 89.55,29.29 C89.55,29.29 89.55,23.32 89.55,23.32 C89.55,23.32 87.5,23.32 87.5,23.32 C87.5,23.32 87.5,21.49 87.5,21.49 C87.5,21.49 93.9,21.49 93.9,21.49 C93.9,21.49 93.9,23.32 93.9,23.32 C93.9,23.32 91.85,23.32 91.85,23.32 C91.85,23.32 91.85,29.29 91.85,29.29z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_4_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M80.18 27 C80.18,27 82.35,27 82.35,27 C82.38,27.21 82.51,27.39 82.74,27.53 C82.98,27.66 83.25,27.73 83.57,27.73 C83.91,27.73 84.17,27.67 84.37,27.55 C84.57,27.42 84.67,27.27 84.67,27.08 C84.67,26.9 84.59,26.76 84.43,26.67 C84.27,26.57 83.98,26.48 83.55,26.41 C83.55,26.41 82.52,26.22 82.52,26.22 C81.8,26.1 81.26,25.84 80.88,25.44 C80.5,25.05 80.31,24.55 80.31,23.93 C80.31,23.15 80.61,22.53 81.2,22.06 C81.8,21.6 82.57,21.36 83.52,21.36 C84.54,21.36 85.34,21.58 85.91,22.02 C86.47,22.46 86.76,23.06 86.77,23.82 C86.77,23.82 84.67,23.82 84.67,23.82 C84.67,23.59 84.56,23.4 84.35,23.26 C84.14,23.12 83.88,23.05 83.56,23.05 C83.26,23.05 83.02,23.11 82.85,23.23 C82.67,23.34 82.58,23.49 82.58,23.69 C82.58,23.87 82.67,24.02 82.83,24.13 C83,24.24 83.27,24.32 83.64,24.39 C83.64,24.39 84.71,24.57 84.71,24.57 C85.47,24.7 86.03,24.95 86.39,25.32 C86.75,25.69 86.93,26.18 86.93,26.82 C86.93,27.61 86.62,28.25 86,28.72 C85.39,29.19 84.56,29.43 83.52,29.43 C82.47,29.43 81.65,29.22 81.06,28.8 C80.48,28.37 80.18,27.77 80.18,27z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_5_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M79.31 29.29 C79.31,29.29 77.02,29.29 77.02,29.29 C77.02,29.29 77.02,21.49 77.02,21.49 C77.02,21.49 79.31,21.49 79.31,21.49 C79.31,21.49 79.31,29.29 79.31,29.29z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_6_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M76.12 25.98 C76.12,27.04 75.79,27.89 75.15,28.5 C74.52,29.12 73.63,29.43 72.51,29.43 C71.26,29.43 70.3,29.08 69.6,28.37 C68.91,27.67 68.57,26.68 68.57,25.39 C68.57,24.12 68.91,23.13 69.59,22.42 C70.28,21.71 71.22,21.36 72.43,21.36 C73.41,21.36 74.23,21.62 74.89,22.13 C75.56,22.65 75.94,23.31 76.02,24.11 C76.02,24.11 73.77,24.11 73.77,24.11 C73.69,23.82 73.54,23.59 73.29,23.42 C73.06,23.25 72.77,23.16 72.44,23.16 C71.96,23.16 71.58,23.36 71.3,23.74 C71.04,24.13 70.9,24.66 70.9,25.35 C70.9,26.06 71.05,26.61 71.35,27.02 C71.65,27.42 72.05,27.62 72.56,27.62 C72.93,27.62 73.24,27.53 73.48,27.34 C73.73,27.15 73.87,26.89 73.9,26.58 C73.9,26.58 73.91,26.47 73.91,26.47 C73.91,26.47 72.72,26.47 72.72,26.47 C72.72,26.47 72.72,24.95 72.72,24.95 C72.72,24.95 76.12,24.95 76.12,24.95 C76.12,24.95 76.12,25.98 76.12,25.98z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_7_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M61.07 22.45 C61.77,21.72 62.73,21.36 63.93,21.36 C65.14,21.36 66.1,21.72 66.8,22.45 C67.51,23.17 67.86,24.15 67.86,25.4 C67.86,26.64 67.51,27.62 66.8,28.35 C66.1,29.07 65.14,29.43 63.93,29.43 C62.72,29.43 61.77,29.07 61.06,28.35 C60.36,27.62 60.01,26.64 60.01,25.4 C60.01,24.15 60.36,23.17 61.07,22.45z  M65.09 23.79 C64.8,23.39 64.41,23.19 63.93,23.19 C63.46,23.19 63.07,23.39 62.78,23.79 C62.49,24.19 62.34,24.72 62.34,25.4 C62.34,26.07 62.49,26.6 62.77,27 C63.07,27.4 63.45,27.6 63.93,27.6 C64.42,27.6 64.8,27.4 65.09,27 C65.38,26.6 65.53,26.07 65.53,25.4 C65.53,24.72 65.38,24.19 65.09,23.79z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_8_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M59.65 27.47 C59.65,27.47 59.65,29.29 59.65,29.29 C59.65,29.29 54.3,29.29 54.3,29.29 C54.3,29.29 54.3,21.49 54.3,21.49 C54.3,21.49 56.6,21.49 56.6,21.49 C56.6,21.49 56.6,27.47 56.6,27.47 C56.6,27.47 59.65,27.47 59.65,27.47z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_9_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M88.74 15.87 C88.74,15.87 88.74,0.25 88.74,0.25 C88.74,0.25 96.6,0.25 96.6,0.25 C96.6,0.25 100.85,9.17 100.85,9.17 C100.85,9.17 105.18,0.25 105.18,0.25 C105.18,0.25 112.7,0.25 112.7,0.25 C112.7,0.25 112.7,15.87 112.7,15.87 C112.7,15.87 107.12,15.87 107.12,15.87 C107.12,15.87 107.12,6.11 107.12,6.11 C107.12,6.11 102.45,15.87 102.45,15.87 C102.45,15.87 98.86,15.87 98.86,15.87 C98.86,15.87 94.24,6.11 94.24,6.11 C94.24,6.11 94.24,15.87 94.24,15.87 C94.24,15.87 88.74,15.87 88.74,15.87 C88.74,15.87 88.74,15.87 88.74,15.87z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_10_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M68.87 14.61 C67.61,13.81 66.74,12.69 66.25,11.25 C65.93,10.3 65.76,9.12 65.76,7.7 C65.76,7.7 65.76,0.25 65.76,0.25 C65.76,0.25 71.43,0.25 71.43,0.25 C71.43,0.25 71.43,7.66 71.43,7.66 C71.43,8.78 71.68,9.64 72.18,10.24 C72.85,11.08 73.99,11.5 75.6,11.5 C75.6,11.5 75.69,11.5 75.69,11.5 C77.28,11.5 78.41,11.08 79.07,10.24 C79.55,9.63 79.79,8.76 79.79,7.66 C79.79,7.66 79.79,0.25 79.79,0.25 C79.79,0.25 85.45,0.25 85.45,0.25 C85.45,0.25 85.45,7.7 85.45,7.7 C85.45,9.03 85.28,10.21 84.92,11.25 C84.42,12.68 83.54,13.8 82.29,14.61 C80.75,15.6 78.65,16.1 75.99,16.1 C75.99,16.1 75.33,16.1 75.33,16.1 C72.59,16.1 70.43,15.6 68.87,14.61z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_11_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M62.32 9.42 C63.02,10.05 63.38,10.93 63.38,12.07 C63.38,12.07 63.38,14.48 63.38,14.48 C63.38,14.89 63.4,15.17 63.44,15.34 C63.48,15.5 63.54,15.64 63.61,15.76 C63.61,15.76 63.61,15.87 63.61,15.87 C63.61,15.87 57.76,15.87 57.76,15.87 C57.72,15.78 57.69,15.68 57.67,15.57 C57.63,15.42 57.61,15.19 57.61,14.9 C57.61,14.9 57.61,13.58 57.61,13.58 C57.61,12.59 57.4,11.9 56.97,11.52 C56.76,11.32 56.47,11.18 56.1,11.1 C55.72,11.02 55.25,10.98 54.67,10.98 C54.67,10.98 49.69,10.98 49.69,10.98 C49.69,10.98 49.69,15.87 49.69,15.87 C49.69,15.87 43.98,15.87 43.98,15.87 C43.98,15.87 43.98,0.25 43.98,0.25 C43.98,0.25 56.68,0.25 56.68,0.25 C59.29,0.25 61.1,0.7 62.13,1.61 C62.87,2.28 63.25,3.25 63.25,4.51 C63.25,4.51 63.25,4.66 63.25,4.66 C63.25,5.71 62.89,6.56 62.17,7.2 C61.52,7.79 60.71,8.17 59.72,8.35 C60.85,8.54 61.71,8.89 62.32,9.42z  M49.69 6.9 C49.69,6.9 55.49,6.9 55.49,6.9 C56.17,6.9 56.66,6.77 56.97,6.49 C57.21,6.26 57.33,5.95 57.33,5.56 C57.33,5.56 57.33,5.52 57.33,5.52 C57.33,5.14 57.21,4.84 56.97,4.62 C56.68,4.37 56.18,4.24 55.49,4.24 C55.49,4.24 49.69,4.24 49.69,4.24 C49.69,4.24 49.69,6.9 49.69,6.9z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_12_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M24.52 0.25 C24.52,0.25 40.22,0.25 40.22,0.25 C40.22,0.25 40.22,4.03 40.22,4.03 C40.22,4.03 30.2,4.03 30.2,4.03 C30.2,4.03 30.2,6.02 30.2,6.02 C30.2,6.02 39.9,6.02 39.9,6.02 C39.9,6.02 39.9,9.91 39.9,9.91 C39.9,9.91 30.2,9.91 30.2,9.91 C30.2,9.91 30.2,12.05 30.2,12.05 C30.2,12.05 40.36,12.05 40.36,12.05 C40.36,12.05 40.36,15.87 40.36,15.87 C40.36,15.87 24.52,15.87 24.52,15.87 C24.52,15.87 24.52,0.25 24.52,0.25z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_13_P_0",
    fill: "#222222",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M15.01 15.87 C15.01,15.87 7.96,15.87 7.96,15.87 C7.96,15.87 0.25,0.25 0.25,0.25 C0.25,0.25 6.86,0.25 6.86,0.25 C6.86,0.25 11.61,10.71 11.61,10.71 C11.61,10.71 16.37,0.25 16.37,0.25 C16.37,0.25 22.34,0.25 22.34,0.25 C22.34,0.25 15.01,15.87 15.01,15.87z "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "time_group"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoAnimated);
export default __webpack_public_path__ + "static/media/header-logo-animated.67cb02b17fb48e6c5966abccec7adb48.svg";
export { ForwardRef as ReactComponent };